(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
      
      // Initialize search overlay functionality
      this.initializeSearchOverlay();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      // Handle search container switching
      this.handleSearchContainerSwitch(scrollTop);

      // Handle secondary navigation visibility based on scroll direction
      this.handleSecondaryNavVisibility(scrollTop);

      // Handle announcement bar visibility based on scroll direction
      // this.handleAnnouncementBarVisibility(scrollTop);

      // Make header sticky when it reaches the top (scroll position 0)
      if (scrollTop > 0) {
        this.header.classList.add('scrolled-past-header');
        requestAnimationFrame(this.makeSticky.bind(this));
        } else {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    handleSecondaryNavVisibility(scrollTop) {
      const headerSecondaryNav = document.querySelector('.header__secondary-nav');
      const isDesktop = window.innerWidth >= 990;
      
      if (!headerSecondaryNav || !isDesktop) return;

      // Add smooth transitions for secondary nav
      if (!headerSecondaryNav.style.transition) {
        headerSecondaryNav.style.transition = 'opacity 0.3s ease, transform 0.3s ease, height 0.3s ease';
      }

      // Show secondary nav when scrolling up, hide when scrolling down
      if (scrollTop > this.currentScrollTop && scrollTop > 100) {
        // Scrolling down - hide secondary nav
        headerSecondaryNav.style.opacity = '0';
        headerSecondaryNav.style.transform = 'translateY(-20px)';
        headerSecondaryNav.style.height = '0';
        headerSecondaryNav.style.position = 'absolute';
        headerSecondaryNav.style.width = '100%';
        headerSecondaryNav.style.overflow = 'hidden';
        headerSecondaryNav.style.pointerEvents = 'none';
        // headerSecondaryNav.style.padding = '0';
      } else if (scrollTop < this.currentScrollTop || scrollTop <= 100) {
        // Scrolling up or at top - show secondary nav
        headerSecondaryNav.style.opacity = '1';
        headerSecondaryNav.style.transform = 'translateY(0)';
        headerSecondaryNav.style.height = 'auto';
        headerSecondaryNav.style.position = 'static';
        headerSecondaryNav.style.overflow = 'visible';
        headerSecondaryNav.style.pointerEvents = 'auto';
        // headerSecondaryNav.style.padding = '19px 0 7px 0';
      }
    }

    // handleAnnouncementBarVisibility(scrollTop) {
    //   const announcementBar = document.querySelector('.announcement-bar-section');
       
    //   if (!announcementBar) return;

    //   // Add smooth transitions for announcement bar
    //   if (!announcementBar.style.transition) {
    //     announcementBar.style.transition = 'opacity 0.3s ease-out, transform 0.3s ease-out, max-height 0.3s ease-out';
    //   }

    //   // Show announcement bar when scrolling up, hide when scrolling down
    //   if (scrollTop > this.currentScrollTop && scrollTop > 50) {
    //     // Scrolling down - hide announcement bar
    //     announcementBar.style.opacity = '0';
    //     announcementBar.style.transform = 'translate(0, -100%)';
    //     announcementBar.style.maxHeight = '0';
    //     announcementBar.style.overflow = 'hidden';
        
    //   } else if (scrollTop < this.currentScrollTop || scrollTop <= 50) {
    //     // Scrolling up or at top - show announcement bar
    //     announcementBar.style.opacity = '1';
    //     announcementBar.style.transform = 'translate(0, 0)';
    //     announcementBar.style.maxHeight = 'none';
    //     announcementBar.style.overflow = 'visible';
    //   }
    // }

    initializeSearchOverlay() {
      const searchInputs = document.querySelectorAll('.header__search-input');
      const searchOverlay = document.getElementById('search-overlay');
      
      if (!searchOverlay) return;

      searchInputs.forEach(input => {
        // Show overlay on focus
        input.addEventListener('focus', () => {
          searchOverlay.classList.add('active');
          document.body.style.overflow = 'hidden'; // Prevent background scrolling
        });

        // Hide overlay on blur
        input.addEventListener('blur', () => {
          searchOverlay.classList.remove('active');
          document.body.style.overflow = ''; // Restore scrolling
        });
      });

      // Hide overlay when clicking on it
      searchOverlay.addEventListener('click', () => {
        searchOverlay.classList.remove('active');
        document.body.style.overflow = ''; // Restore scrolling
        
        // Blur all search inputs
        searchInputs.forEach(input => {
          input.blur();
        });
      });
    }

    handleSearchContainerSwitch(scrollTop) {
      const staticSearchContainer = document.querySelector('.static-search-container');
      const stickySearchContainer = document.querySelector('.sticky-search-container');
      const headerHeadingLink = document.querySelectorAll('.header__heading, .header__heading-link');
      const headerSecondaryNav = document.querySelector('.header__secondary-nav');
      const headertag = document.querySelectorAll('.header');
      const isMobile = window.innerWidth <= 989;
      const isDesktop = window.innerWidth >= 990;

      // Debug logs
      console.log('ScrollTop:', scrollTop, 'isMobile:', isMobile, 'headertag:', headertag);

      // Add mobile scroll class to header
      if (headertag.length > 0 && isMobile) {
        if (scrollTop > 0) {
          headertag.forEach(tag => tag.classList.add('mobile-scrolled'));
          console.log('Added mobile-scrolled class to header'); // Debug log
        } else {
          headertag.forEach(tag => tag.classList.remove('mobile-scrolled'));
          console.log('Removed mobile-scrolled class from header'); // Debug log
        }
      }

      // Add smooth transitions only for header elements (not search containers)
      if (headerSecondaryNav && !headerSecondaryNav.style.transition) {
        headerSecondaryNav.style.transition = 'opacity 0.3s ease, transform 0.3s ease, height 0.3s ease';
      }

      if (staticSearchContainer && stickySearchContainer) {
        if (scrollTop === 0) {
          // At top - show static, hide sticky
          // First, hide sticky search container to free up space
          stickySearchContainer.style.display = 'none';
          staticSearchContainer.style.display = 'block';

          // Then show header heading link on mobile when at top
          if (headerHeadingLink && isMobile) {
            headerHeadingLink.forEach(link => {
              link.style.display = 'block';
              link.style.visibility = 'visible';
              link.style.pointerEvents = 'auto';
              link.style.transition = 'opacity 0.2s ease';
              setTimeout(() => {
                link.style.opacity = '1';
              }, 10);
            });
          }

          // Show header secondary nav on desktop when at top
          if (headerSecondaryNav && isDesktop) {
            headerSecondaryNav.style.opacity = '1';
            headerSecondaryNav.style.transform = 'translateY(0)';
            headerSecondaryNav.style.height = 'auto';
            headerSecondaryNav.style.position = 'static';
          }
        } else {
          // Scrolled - hide static, show sticky
          // First, hide header heading link immediately to prevent overlap glitch
          if (headerHeadingLink && isMobile) {
            headerHeadingLink.forEach(link => {
              // Hide display immediately to free up space
              link.style.display = 'none';
              link.style.visibility = 'hidden';
              link.style.opacity = '0';
              link.style.pointerEvents = 'none';
            });
          }
          
          // Then show sticky search container (no delay needed since heading is already hidden)
          staticSearchContainer.style.display = 'none';
          stickySearchContainer.style.display = 'block';
        }
      }
    }

    makeSticky() {
      // Make header sticky without hiding it
      this.header.classList.add('shopify-section-header-sticky');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // Live Search Functionality
  class LiveSearch {
    constructor() {
      // Find all search inputs and dropdowns with unique IDs
      this.searchInputs = document.querySelectorAll('[id^="Search-In-Header"]');
      this.searchDropdowns = document.querySelectorAll('[id^="search-dropdown"]');
      this.suggestionLists = document.querySelectorAll('[id^="suggestion-list"]');
      this.productsGrids = document.querySelectorAll('[id^="products-grid"]');
      this.viewAllBtns = document.querySelectorAll('[id^="view-all-btn"]');
      
      this.searchTimeout = null;
      this.blurTimeout = null;
      this.isDropdownHovered = false;
      this.isActive = false; // Track if search is currently active
      this.currentQuery = ''; // Track current search query
      this.currentSearchInput = null; // Track which input is currently active

      this.init();
    }

    init() {
      if (this.searchInputs.length === 0) return;

      // Add event listeners to all search inputs
      this.searchInputs.forEach((input, index) => {
        input.addEventListener('input', (e) => this.handleInput(e, index));
        input.addEventListener('focus', (e) => this.handleFocus(e, index));
        input.addEventListener('blur', (e) => this.handleBlur(e, index));
      });

      // Dropdown hover tracking for all dropdowns
      this.searchDropdowns.forEach((dropdown, index) => {
        dropdown.addEventListener('mouseenter', () => {
          this.isDropdownHovered = true;
          // Cancel any pending blur timeout when hovering dropdown
          if (this.blurTimeout) {
            clearTimeout(this.blurTimeout);
            this.blurTimeout = null;
          }
        });

        dropdown.addEventListener('mouseleave', () => {
          this.isDropdownHovered = false;
          // If input doesn't have focus, hide dropdown after a delay
          if (!this.currentSearchInput || !this.currentSearchInput.matches(':focus')) {
            this.blurTimeout = setTimeout(() => {
              this.hideDropdown();
            }, 150);
          }
        });
      });

      // Prevent dropdown clicks from bubbling up to global handlers
      this.searchDropdowns.forEach((dropdown) => {
        dropdown.addEventListener('click', (e) => {
          e.stopPropagation();
        });
      });

      // Prevent search container clicks from bubbling up
      this.searchInputs.forEach((input) => {
        const container = input.closest('.header__search-container');
        if (container) {
          container.addEventListener('click', (e) => {
            e.stopPropagation();
          });
        }
      });

      // Prevent dropdown from showing on empty click
      this.searchInputs.forEach((input) => {
        input.addEventListener('click', (e) => {
          const query = e.target.value.trim();
          if (query.length < 2) {
            this.clearDropdown();
          }
        });
      });

      // Close dropdown when clicking outside - use capture phase to get priority
      document.addEventListener('click', this.handleClickOutside.bind(this), true);

      // Handle Escape key to close dropdown
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          this.hideDropdown();
          if (this.currentSearchInput) {
            this.currentSearchInput.blur();
          }
        }
      });
    }

    handleInput(e, inputIndex) {
      const query = e.target.value.trim();
      this.currentSearchInput = e.target;

      // Clear any existing timeouts
      clearTimeout(this.searchTimeout);
      if (this.blurTimeout) {
        clearTimeout(this.blurTimeout);
        this.blurTimeout = null;
      }

      if (query.length < 2) {
        this.clearDropdown();
        return;
      }

      // Show dropdown immediately with loading state if not already shown
      const currentDropdown = this.searchDropdowns[inputIndex];
      if (currentDropdown && currentDropdown.style.display === 'none') {
        this.showDropdown(inputIndex);
        this.showLoading(inputIndex);
      }

      this.searchTimeout = setTimeout(() => {
        this.performSearch(query, inputIndex);
      }, 300);
    }

    handleFocus(e, inputIndex) {
      this.currentSearchInput = e.target;
      // Only show dropdown if there's a query AND we have content to show
      const query = e.target.value.trim();
      if (query.length >= 2 && this.hasContent(inputIndex)) {
        this.showDropdown(inputIndex);
      }
    }

    handleBlur(e, inputIndex) {
      // Clear any existing blur timeout
      if (this.blurTimeout) {
        clearTimeout(this.blurTimeout);
      }

      // Delay hiding to allow clicking on dropdown items
      this.blurTimeout = setTimeout(() => {
        // Only hide if not hovering over dropdown, input doesn't have focus, and user isn't interacting
        if (!this.isDropdownHovered &&
            !e.target.matches(':focus') &&
            document.activeElement !== e.target) {
          this.hideDropdown();
        }
      }, 250);
    }

    handleClickOutside(e) {
      // Only process if search is active
      if (!this.isActive) return;

      // Only hide if clicking completely outside the search container
      const searchContainer = this.searchInput.closest('.header__search-container');

      // Check if click is inside search dropdown or search container
      if (searchContainer && !searchContainer.contains(e.target)) {
        // Additional check: don't close if clicking on other interactive elements
        const isClickingOnMenu = e.target.closest('.mega-menu, .menu-drawer, .select__menu, .color-swatch-link');
        const isClickingOnButton = e.target.closest('button, .triggerClick, .klaviyo-bis-trigger');

        if (!isClickingOnMenu && !isClickingOnButton) {
          this.hideDropdown();
        }
      }
    }

    hasContent(inputIndex = 0) {
      // Check if we have any content to show in the dropdown
      const productsGrid = this.productsGrids[inputIndex];
      const suggestionList = this.suggestionLists[inputIndex];
      const hasProducts = productsGrid && productsGrid.children.length > 0;
      const hasSuggestions = suggestionList && suggestionList.children.length > 0;
      return hasProducts || hasSuggestions;
    }

    async performSearch(query, inputIndex = 0) {
      // Only show dropdown and loading if user has typed something
      if (query.length >= 2) {
        this.showDropdown(inputIndex);
        this.showLoading(inputIndex);

        try {
          // Update view all button with current query
          const viewAllBtn = this.viewAllBtns[inputIndex];
          if (viewAllBtn) {
            viewAllBtn.onclick = () => {
              this.currentSearchInput.closest('form').submit();
            };
          }

          // First try predictive search API
          await this.fetchAndDisplayProducts(query, inputIndex);

        } catch (error) {
          console.error('Search error:', error);
          this.showNoResults(inputIndex);
        }
      } else {
        // Hide dropdown if query is too short
        this.hideDropdown();
      }
    }


    async displaySuggestions(query, inputIndex = 0) {
      try {
        const suggestions = await this.fetchDynamicSuggestions(query);
        const suggestionList = this.suggestionLists[inputIndex];

        if (suggestionList) {
          suggestionList.innerHTML = suggestions.map(suggestion =>
            `<a href="/search?q=${encodeURIComponent(suggestion)}" class="search-dropdown__suggestion">${suggestion}</a>`
          ).join('');
        }

        // Update VIEW ALL button with current query
        this.updateViewAllButton(query, inputIndex);
      } catch (error) {
        console.error('Error fetching suggestions:', error);
        // Fallback to basic suggestions
        const fallbackSuggestions = this.generateFallbackSuggestions(query);
        const suggestionList = this.suggestionLists[inputIndex];
        
        if (suggestionList) {
          suggestionList.innerHTML = fallbackSuggestions.map(suggestion =>
            `<a href="/search?q=${encodeURIComponent(suggestion)}" class="search-dropdown__suggestion">${suggestion}</a>`
          ).join('');
        }

        // Update VIEW ALL button with current query
        this.updateViewAllButton(query, inputIndex);
      }
    }

    async fetchDynamicSuggestions(query) {
      // Fetch suggestions from Shopify's suggest API
      const suggestUrl = `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=query&resources[limit]=4`;

      const response = await fetch(suggestUrl);
      if (!response.ok) throw new Error('Suggestions API failed');

      const data = await response.json();
      console.log('Suggestions data:', data);

      let suggestions = [];

      // Extract query suggestions if available
      if (data.resources && data.resources.queries) {
        suggestions = data.resources.queries.map(q => q.text);
      } else if (data.resources && data.resources.results && data.resources.results.queries) {
        suggestions = data.resources.results.queries.map(q => q.text);
      }

      // If no query suggestions, try to extract from products/collections
      if (suggestions.length === 0) {
        // Try to get suggestions from product titles, vendors, or types
        const productSuggestUrl = `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=10`;
        const productResponse = await fetch(productSuggestUrl);

        if (productResponse.ok) {
          const productData = await productResponse.json();
          let products = [];

          if (productData.resources && productData.resources.products) {
            products = productData.resources.products;
          } else if (productData.resources && productData.resources.results && productData.resources.results.products) {
            products = productData.resources.results.products;
          }

          // Extract unique vendors, product types, and keywords from products
          const vendors = [...new Set(products.map(p => p.vendor).filter(v => v))];
          const types = [...new Set(products.map(p => p.type || p.product_type).filter(t => t))];

          // Create suggestions based on the query + categories found
          suggestions = [
            ...vendors.slice(0, 2),
            ...types.slice(0, 2),
            `${query} accessories`,
            `${query} gear`
          ].filter((suggestion, index, self) =>
            suggestion &&
            suggestion.toLowerCase().includes(query.toLowerCase()) &&
            self.indexOf(suggestion) === index
          );
        }
      }

      // Fallback if still no suggestions
      if (suggestions.length === 0) {
        suggestions = this.generateFallbackSuggestions(query);
      }

      return suggestions.slice(0, 4);
    }

    generateFallbackSuggestions(query) {
      // Fallback suggestions based on query
      return [
        `${query} boots`,
        `${query} jackets`,
        `${query} accessories`,
        `${query} gear`
      ];
    }

    async fetchAndDisplayProducts(query, inputIndex = 0) {
      try {
        console.log('Searching for:', query);

        // Store current query for VIEW ALL button
        this.currentQuery = query;

        // First, generate search suggestions (now async)
        await this.displaySuggestions(query, inputIndex);

        // Fetch the predictive search products HTML which contains rendered card-product snippets
        const searchUrl = `/search?q=${encodeURIComponent(query)}&section_id=predictive-search-products`;
        console.log('Fetching rendered cards from:', searchUrl);

        const response = await fetch(searchUrl);
        console.log('Response status:', response.status);

        if (response.ok) {
          const html = await response.text();
          console.log('Got HTML response, extracting cards...');

          // Extract the first 5 rendered product cards
          const renderedCards = this.extractProductCardsFromHTML(html);

          if (renderedCards.length > 0) {
            console.log('Found rendered cards:', renderedCards.length);
            this.displayRenderedProducts(renderedCards.slice(0, 5), query, inputIndex);
          } else {
            console.log('No rendered cards found, trying fallback...');
            this.showNoResults(inputIndex);
          }
        } else {
          throw new Error(`Search page failed with status: ${response.status}`);
        }

      } catch (error) {
        console.error('Search error:', error);
        this.showNoResults(inputIndex);
      }
    }

    extractProductCardsFromHTML(html) {
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = html;

      // Look for the product grid in the predictive search results
      let productGrid = tempDiv.querySelector('#product-grid ul') ||
                       tempDiv.querySelector('.predictive-search-products ul') ||
                       tempDiv.querySelector('.grid.product-grid') ||
                       tempDiv.querySelector('ul[role="list"]');

      console.log('Product grid found:', !!productGrid);

      if (!productGrid) {
        // Try to find any ul that contains grid items with card-wrapper
        const allUls = tempDiv.querySelectorAll('ul');
        for (let ul of allUls) {
          if (ul.querySelector('.grid__item .card-wrapper')) {
            productGrid = ul;
            console.log('Found product grid via card-wrapper search');
            break;
          }
        }
      }

      if (!productGrid) {
        console.log('No product grid found in HTML');
        return [];
      }

      // Extract all grid items (which contain the rendered card-product snippets)
      const gridItems = productGrid.querySelectorAll('.grid__item');
      console.log(`Found ${gridItems.length} grid items`);

      // Return the HTML of each grid item (these are already rendered card-product snippets)
      return Array.from(gridItems).map(item => item.outerHTML);
    }



    displayRenderedProducts(productHTMLArray, query = '', inputIndex = 0) {
      // Display the pre-rendered product cards directly
      const productsGrid = this.productsGrids[inputIndex];
      if (productsGrid) {
        productsGrid.innerHTML = productHTMLArray.join('');
      }

      // Update view all button with current query or passed query
      this.updateViewAllButton(query || this.currentQuery, inputIndex);
    }

    updateViewAllButton(query, inputIndex = 0) {
      const viewAllBtn = this.viewAllBtns[inputIndex];
      if (viewAllBtn && query) {
        viewAllBtn.onclick = (e) => {
          e.preventDefault();
          window.location.href = `/search?q=${encodeURIComponent(query)}`;
        };
      }
    }


    extractPriceFromText(text) {
      // Extract numeric price from text like "$99.99", "€99,99", etc.
      const priceMatch = text.match(/[\d,]+\.?\d*/);
      return priceMatch ? parseFloat(priceMatch[0].replace(',', '')) : 0;
    }





    showDropdown(inputIndex = 0) {
      const dropdown = this.searchDropdowns[inputIndex];
      if (dropdown) {
        dropdown.style.display = 'block';
        this.isActive = true;
      }
    }

    hideDropdown() {
      // Hide all dropdowns
      this.searchDropdowns.forEach(dropdown => {
        if (dropdown) {
          dropdown.style.display = 'none';
        }
      });
      this.isActive = false;
      // Clear any pending timeouts
      if (this.blurTimeout) {
        clearTimeout(this.blurTimeout);
        this.blurTimeout = null;
      }
    }

    showLoading(inputIndex = 0) {
      const suggestionList = this.suggestionLists[inputIndex];
      const productsGrid = this.productsGrids[inputIndex];
      
      if (suggestionList) {
        suggestionList.innerHTML = '';
      }
      if (productsGrid) {
        productsGrid.innerHTML = '<div class="search-dropdown__loading">Searching...</div>';
      }
    }

    showNoResults(inputIndex = 0) {
      const suggestionList = this.suggestionLists[inputIndex];
      const productsGrid = this.productsGrids[inputIndex];
      
      if (suggestionList) {
        suggestionList.innerHTML = '';
      }
      if (productsGrid) {
        productsGrid.innerHTML = '<div class="search-dropdown__no-results">No results found. Try a different search term.</div>';
      }
    }

    clearDropdown() {
      // Clear all timeouts first
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
        this.searchTimeout = null;
      }
      if (this.blurTimeout) {
        clearTimeout(this.blurTimeout);
        this.blurTimeout = null;
      }

      // Clear content for all dropdowns
      this.suggestionLists.forEach(list => {
        if (list) {
          list.innerHTML = '';
        }
      });
      this.productsGrids.forEach(grid => {
        if (grid) {
          grid.innerHTML = '';
        }
      });

      // Hide dropdown
      this.hideDropdown();
    }
  }

  // Initialize live search when DOM is loaded
  document.addEventListener('DOMContentLoaded', () => {
    window.liveSearchInstance = new LiveSearch();
  });

  } catch(e) { console.error(e); }
})();
})();
